import axios from 'axios'
import HTTP from './http'

export default {
    getList: () => axios.get(HTTP.SPECIALIZATION_SPECIALITY),
    dlt: id => axios.delete(HTTP.SPECIALIZATION_SPECIALITY, { params: id }),
    add: payload => axios.post(HTTP.SPECIALIZATION_SPECIALITY, { payload })
}
